<script lang="ts" setup>
import type { Transcription } from '../logic'
import { useAudioPlayer, useComments } from '../logic'

const props = defineProps<{
  cue: Transcription.IContentSentence
}>()

const comments = useComments()

const entries = computed(() =>
  comments.list.filter(
    entry => entry.seconds >= props.cue.start && entry.seconds < props.cue.end
  )
)

function showCommentsDialog() {
  const { audio } = useAudioPlayer()
  const { start } = props.cue

  audio.currentTime = start

  if (comments.enabled) {
    comments.showDialog(start, entries.value)
    track('Comments: clicked caption text')
  }
}

function highlightComments(show = true) {
  if (comments.enabled)
    comments.setHighlightedComments(show ? entries.value : [])
}
</script>

<template>
  <span
    class="cursor-pointer transition-colors transition-delay-50 [&:hover,&.draft-active]:text-$color-primary [&:hover,&.draft-active]:bg-transparent"
    :class="{ 'draft-active': comments.dialog.enabled && comments.dialog.draft.time === props.cue.start }"
    @click="showCommentsDialog"
    @mouseover="highlightComments()"
    @mouseout="highlightComments(false)"
  >
    {{ cue.text }}

    <span
      v-if="comments.enabled && entries.length"
      class="select-none flex-center flex-inline size-21px text-xs align-middle rounded-3xl bg-$color-background-elevated-2 text-$color-text-on-background"
    >
      {{ entries.length }}
    </span>
  </span>
</template>
